import Axios from "../plugins/Axios";

class FundebService {
  async getParameters(ano) {
    const response = await Axios().get(`/fundeb/parameters/${ano}`);
    return response.data;
  }

  async storeCalculation(data) {
    const response = await Axios().post(`/fundeb/calculate`, data);
    return response.data;
  }

  async updateParameters(data) {
    const response = await Axios().post(`/fundeb/parameters`, data);
    return response.data;
  }

  async getHistory() {
    const response = await Axios().get(`/fundeb/history`);
    return response.data;
  }
}

export default new FundebService();
